<template>
  <div>
    <details-modal
      :show="modals.country"
      :current-operation="currentOperation"
      @cancel="closeModal"
      @create="createRecord"
      @delete="deleteRecord"
      @update="updateRecord"
    >
      <form>
        <fg-input v-model="country.name" type="text" label="Nom" />
        <fg-input v-model="country.code" type="text" label="Code" />
      </form>
      <p class="errorMessageInModal">{{ errorMessage }}</p>
    </details-modal>
    <div class="row">
      <div class="col-md-12">
        <crud-list
          ref="crudList"
          :fetch-data="fetchCountries"
          title="Pays"
          @create="create"
          @row-clicked="countryRowClicked"
        >
          <el-table-column label="Pays" min-width="80" property="name" />
          <el-table-column label="Code" min-width="20"
            ><div slot-scope="slotScope">
              {{ slotScope.row.code }}&nbsp;
            </div></el-table-column
          >
        </crud-list>
      </div>
    </div>
  </div>
</template>

<script>
import DetailsModal from './Modals/DetailsModal.vue';
import CrudList from './CrudList.vue';

export default {
  components: {
    CrudList,
    DetailsModal,
  },
  data() {
    return {
      modals: {
        country: false,
      },
      currentOperation: {},
      country: {},
      errorMessage: ' ',
    };
  },
  methods: {
    countryRowClicked(row) {
      this.currentOperation = 'edit';
      this.country = { ...row };
      this.modals.country = true;
    },
    fetchCountries(pageNumber, pageSize, searchText) {
      let url = process.env.VUE_APP_ANNUAIRE_API_URL;
      if (searchText) {
        url += `/countryEntities/search/fulltext?sort=name&name=${searchText}&code=${searchText}&page=${pageNumber -
          1}&size=${pageSize}`;
      } else {
        url += `/countryEntities?sort=name&page=${pageNumber -
          1}&size=${pageSize}`;
      }
      return this.$http.get(url).then(response => ({
        records: response.data._embedded.countryEntities
          ? response.data._embedded.countryEntities
          : [],
        page: response.data.page,
      }));
    },
    deleteRecord() {
      this.$http
        .delete(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/countries/${this.country.id}`,
        )
        .then(response => {
          this.$refs.crudList.fetch();
          this.errorMessage = '';
          this.modals.country = false;
        })
        .catch(error => {
          this.errorMessage = error.response.data.message;
        });
    },
    updateRecord() {
      this.$http
        .patch(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/countries/${this.country.id}`,
          {
            code: this.country.code,
            name: this.country.name,
          },
        )
        .then(response => {
          this.$refs.crudList.fetch();
          this.errorMessage = '';
          this.modals.country = false;
        })
        .catch(error => {
          this.errorMessage = error.response.data.message;
        });
    },
    createRecord() {
      this.$http
        .post(`${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/countries/`, {
          code: this.country.code,
          name: this.country.name,
        })
        .then(response => {
          this.$refs.crudList.fetch();
          this.errorMessage = '';
          this.modals.country = false;
        })
        .catch(error => {
          this.errorMessage = error.response.data.message;
        });
    },
    create() {
      this.country = {};
      this.currentOperation = 'create';
      this.modals.country = true;
    },
    closeModal() {
      this.modals.country = false;
      this.errorMessage = '';
    },
  },
};
</script>

<style scoped></style>
